import common from "./pt-PT/common";

export const resources = {
    pt: {
        common,
    },
};

export default resources;